import type { FilesAvailable } from '@/data/payrollCheck/models/filesModels';
import Payroll from '@/shared/api/payroll';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

export const fetchFilesAvailable = createWiwAsyncThunk<FilesAvailable, string>(
  'payrollCheck/fetchFilesAvailable',
  async (id: string, { rejectWithValue }) => {
    try {
      return await Payroll.get(`/payrolls/${id}/files-available`);
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
